/** Get Summary Dashboard data */
export const SUMMARY_DATA_API_SUCCESS = "SUMMARY_DATA_API_SUCCESS";
export const SUMMARY_DATA_API_FAIL = "SUMMARY_DATA_API_FAIL";
export const GET_SUMMARY_DATA= "GET_SUMMARY_DATA";
export const GET_SUMMARY_CHART_DATA= "GET_SUMMARY_CHART_DATA";
export const SET_LOADING= "SET_LOADING";